import * as types from './mutation-types'

export default { 
  [types.SET_GENERAL_SETTINGS](state, payload = { generalSettings }) {
    state.generalSettings = payload.generalSettings  
    state.cache.generalSettingsLoaded = true  
  },   
}
